import { UserPermission } from '@/modules/permission/enum';
export const departmentRoutes = [
    {
        path: '',
        name: 'Department',
        exact: true,
        component: () => import('../views/DepartmentIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Department', label: 'Manage Departments' }],
            permissions: [UserPermission.WRITE_DEPARTMENT],
        },
    },
];
